import { Button } from "@/components/ui/button";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

/**
 * Simple offset-based pagination footer.
 * - Renders nothing when `total <= perPage`.
 * - Keeps the layout consistent across the app: "X – Y sur N" + prev/next.
 */
export default function Pagination({ page, total, perPage, onChange, testIdPrefix = "pagination" }) {
    const totalPages = Math.max(1, Math.ceil(total / perPage));
    if (total <= perPage) return null;
    const start = (page - 1) * perPage + 1;
    const end = Math.min(page * perPage, total);
    const go = (p) => onChange(Math.max(1, Math.min(totalPages, p)));

    return (
        <div className="flex items-center justify-between gap-3 pt-4 mt-2 border-t border-border"
             data-testid={testIdPrefix}>
            <span className="text-xs text-muted-foreground" data-testid={`${testIdPrefix}-range`}>
                {start}–{end} sur {total}
            </span>
            <div className="flex items-center gap-1">
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => go(page - 1)}
                    disabled={page <= 1}
                    data-testid={`${testIdPrefix}-prev`}
                >
                    <CaretLeft size={14} />
                </Button>
                <span className="text-xs tabular px-2" data-testid={`${testIdPrefix}-current`}>
                    {page} / {totalPages}
                </span>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={() => go(page + 1)}
                    disabled={page >= totalPages}
                    data-testid={`${testIdPrefix}-next`}
                >
                    <CaretRight size={14} />
                </Button>
            </div>
        </div>
    );
}
